let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fWdHm")).then(() => parcelRequire('6TwJU'));